import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formControlActions } from 'store/formControlSlice/formControlSlice';
import * as formSelectors from 'store/formControlSlice/formControlSelectors';

export const AGENT_TIME_FIELD = 'agentTime';

const INPUT_FIELD_SELECTOR = [
    'input:not([type="submit"]):not([type="reset"]):not([type="button"]):not([type="hidden"])',
    'select',
    'textarea',
    '[contenteditable="true"]',
    '[role="combobox"]',
    '[role="spinbutton"]',
    '[role="textbox"]',
].join(', ');

const useAgentTimeTracker = ({ transactionId, formRef, enabled = true }) => {
    const dispatch = useDispatch();

    const { formStateSelector, transactionDataSelector } = useMemo(
        () => ({
            formStateSelector: formSelectors.createFormStateByTransactionIdSelector(transactionId),
            transactionDataSelector: formSelectors.selectTransactionDataByTransactionId(transactionId),
        }),
        [transactionId]
    );

    const formState = useSelector(formStateSelector);
    const transactionData = useSelector(transactionDataSelector);

    const isAlreadySet = Boolean(formState?.values?.[AGENT_TIME_FIELD] || transactionData?.[AGENT_TIME_FIELD]);

    useEffect(() => {
        if (!enabled || !transactionId || isAlreadySet) return undefined;
        const formEl = formRef?.current;
        if (!formEl) return undefined;

        const handler = (event) => {
            if (!event.isTrusted) return;

            const target = event.target;
            if (!target?.closest?.(INPUT_FIELD_SELECTOR)) return;

            formEl.removeEventListener('focusin', handler);

            dispatch(
                formControlActions.setFieldValue({
                    formId: transactionId,
                    fieldName: AGENT_TIME_FIELD,
                    value: new Date().toISOString(),
                })
            );
        };

        formEl.addEventListener('focusin', handler);

        return () => {
            formEl.removeEventListener('focusin', handler);
        };
    }, [enabled, transactionId, isAlreadySet, formRef, dispatch]);
};

export default useAgentTimeTracker;
